import { useState, useRef, useCallback } from "react";

const UPDATE_STATE_DEAD_ZONE_MS = 300;

/**
 * Working around a bug with DropdownMenuProvider fighting itself; the trigger
 * onClick and the providers onMenuClosed callbacks both try and control the
 * state of the menu in the event of closing the menu by clicking the trigger.
 *
 * This hook ensures that any subsequent calls to setIsOpen are ignored for 300ms.
 *
 * @todo remove this hack once we move off our own DropdownMenu implemention in
 * favour of Radix UI's Popover component.
 */
export function useDropdownOpenState() {
  const [isOpen, _setIsOpen] = useState<boolean>(false);
  const justUpdatedStateRef = useRef<boolean>(false);

  const setIsOpen = useCallback((value: boolean) => {
    if (justUpdatedStateRef.current) return;

    _setIsOpen(value);

    justUpdatedStateRef.current = true;
    setTimeout(() => (justUpdatedStateRef.current = false), UPDATE_STATE_DEAD_ZONE_MS);
  }, []);

  return { isOpen, setIsOpen };
}
